
import Headline from '../ui/Headline';
import Text from '../ui/Text';

type CompetenceCardProps = {
  item: { title: string; text: string; image?: string }
}

function CompetenceCard({ item }: CompetenceCardProps) {
  const { title, text, image } = item
  return (
    <article className="flex flex-col flex-1">
      <div className="relative aspect-video md:aspect-[4/3] w-full overflow-hidden bg-lightGray">
      <>
            <img
              src={image}
              alt=""
              className="h-full w-full object-cover"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
            <div className="absolute inset-0 bg-blue/30 mix-blend-multiply" aria-hidden />
          </>
      </div>
      <Headline headline={title} className="mt-4 md:mt-6" size="xlarge" />
      <Text text={text} className="mt-2 md:mt-4" size="large" />
    </article>
  )
}

export default CompetenceCard
